export const favorite_action = "favorite_action/change";


export const favoriteChange = (id, selected, callback=null) => ({
    type: favorite_action,
    payload: {
        id,
        selected,
        callback
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/favorite.js